import { ProfileTranslationType } from "../../features/profile.types";

export const profile: ProfileTranslationType = {
  profile: {
    title: "Profile",
    dangerZone: "Danger Zone",
    deleteAccount: "Delete Account",
    confirmDelete: "Confirm Deletion",
    deleteWarning: "Are you sure you want to delete your account? This action is irreversible.",
    confirmDeleteButton: "Delete Account",
    accountDeleted: "Account Deleted",
    accountDeletedMessage: "Your account has been successfully deleted."
  },
  common: {
    cancel: "Cancel",
    delete: "Delete",
    deleteConfirmation: "Delete Confirmation",
    deleteConfirmationMessage: "Are you sure you want to delete"
  }
};
